import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { approveAllOvertimeApi, getOvertimeApi } from "./overtimeApi";

export const getReportOvertimeRequest = createAsyncThunk(
  "getReportOvertimeRequest/overtime",
  async (payload: any) => {
    console.log("PR", payload);

    try {
      const response = await getOvertimeApi(payload);
      return response;
    } catch (error) {}
  }
);

export const approveAllOvertimeRequest = createAsyncThunk(
  "approveAllOvertimeRequest/overtime",
  async () => {
    try {
      const response = await approveAllOvertimeApi();
      return response;
    } catch (error) {}
  }
);

interface IInitialState {
  message: string;
  pageIsLoading: boolean;
  lists: any[];
  approvedAll: any;
}

const initialState: IInitialState = {
  message: "",
  lists: [],
  pageIsLoading: false,
  approvedAll: null,
};

const overtimeSlice = createSlice({
  name: "overtime",
  initialState: initialState,
  reducers: {
    resetMessageLevel: (state) => {
      state.message = "";
    },
  },
  extraReducers(builder) {
    // get overtime reducer
    builder.addCase(getReportOvertimeRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getReportOvertimeRequest.fulfilled, (state, action) => {
      console.log("AP", action.payload);

      if (action.payload.status !== 1000) {
        state.lists = action.payload.message;
        state.pageIsLoading = false;
      } else {
        state.lists = action.payload.data;
        state.message = action.payload.message;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getReportOvertimeRequest.rejected, (state) => {
      state.message = "get report overtime is FAIL";
      state.pageIsLoading = false;
    });

    // approve all reducer
    builder.addCase(approveAllOvertimeRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(approveAllOvertimeRequest.fulfilled, (state, action) => {
      console.log("AP", action.payload);

      if (action.payload.status !== 1000) {
        state.approvedAll = action.payload.message;
        state.pageIsLoading = false;
      } else {
        state.approvedAll = action.payload.data;
        state.message = action.payload.message;
        state.pageIsLoading = false;
      }
    });
    builder.addCase(approveAllOvertimeRequest.rejected, (state) => {
      state.message = "approve all overtime is FAIL";
      state.pageIsLoading = false;
    });
  },
});

export const { resetMessageLevel } = overtimeSlice.actions;
export default overtimeSlice.reducer;
